import React from 'react';

const Brazil = () => (
      <div className='br'>
        <h1>Some info about Brazil</h1>

          <p></p>

          <p>
          <a href="/scribbles/bureaucracy/index.html">Bureaucracy</a>
          </p>
          
          <p>
          <a href="/scribbles/invalid-certs.html">Invalid certificates on Brazil Government sites</a>
          </p>

          <p>
          <a href="/scribbles/directions-to-IFT.html">Directions to IFT</a>
          </p>

          <p>
          <a href="/scribbles/hotels/index.html">Hotels near IFT</a>
          </p>

          <p>
          <a href="/scribbles/telephone.html">How to use telephone</a>
          </p>
      
          <p>
          <a href="https://play.google.com/store/apps/details?id=org.mistergroup.shouldianswer&hl=pt&gl=US">
            <img src="/images/devo-atender.png"></img> ``Should I answer?'' --- an excellent Android app to block unwanted phone calls
          </a> 
          </p>

      </div>
)

export default Brazil;
